/* eslint-disable */
import React from 'react';

const GenerateReportToast = (props) => {
    const handleApply = (apply) => {
        if (apply) {
            props.generateAiReports()
        }
        props.closeToast()
    }

    return (
        <div className='generate-ai-reports-alert'>
            <p className='p1'>Make sure you have all clients' data uploaded before generating reports for the current filters.</p>
            <p className='p1'>{`Are you ready to generate reports on the ${props.page} page?`}</p>
            <div className='generate-btn-section'><button onClick={() => handleApply(true)}>Generate Reports</button><button onClick={() => handleApply(false)}>Cancel</button></div>
        </div>
    )

}

export default GenerateReportToast;